import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ModalController, NavParams, Platform } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
// import { KolektorPenagihanAddComponent } from '../kolektor-penagihan-add/kolektor-penagihan-add.component';
import { IzinPreviewComponent } from 'src/app/izin/izin-preview/izin-preview.component';
import { PreviewImageNotokenComponent } from 'src/app/shared/preview-image-notoken/preview-image-notoken.component';
import { DomSanitizer } from '@angular/platform-browser';
import { PreviewPhotoLaporanComponent } from 'src/app/shared/preview-photo-laporan/preview-photo-laporan.component';
import { MemorandumApproveRejectComponent } from '../../approval-memorandum/memorandum-approve-reject/memorandum-approve-reject.component';
import { MemorandumRevisiComponent } from '../../memorandum/memorandum-revisi/memorandum-revisi.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CompanyStorageService } from 'src/app/core/company/company.storage';

@Component({
  selector: 'app-memorandum-app-detail',
  templateUrl: './memorandum-app-detail.component.html',
  styleUrls: ['./memorandum-app-detail.component.scss'],
})
export class MemorandumAppDetailComponent implements OnInit {
  private readonly mandatoryPhotoKeys: string[] = [
    'tampak_depan',
    'ruang_tamu',
    'tampak_jalan',
    'dapur',
    'kamar',
    'kamar_mandi',
    'foto_token_listrik',
    'tampak_belakang',
    'tampak_samping_1',
    'tampak_samping_2',
    'tampak_dashboard',
  ];

  load: boolean = false;
  saving: any = {};
  idData: any;

  detData: any = {};
  det: any;
  tampilData: boolean = false;

  cabang: any = '';
  grup: any = '';
  nama: any = '';
  nip: any = '';
  jabatan: any = '';
  phone: any = '';
  email: any = '';
  username: any = '';
  password: any = '';

  usertype: any = '';

  selct: any = '';

  disabledInput: boolean = false;
  detList: any = {};

  id: any;
  ids: any;

  form: any;
  amor: any;

  riwPem: any = {};
  rw: any;

  riwayat_collector: any;
  penagihan_tertunda: any;
  riwayat_pemby: any;

  lead_id: any = '';

  detail: any = {};
  // det: any = {};
  agunan: any = {};
  credit_checking: any = {};
  header: any = {};
  pasangan: any = {};
  pemohon: any = {};
  pengajuan: any = {};
  penjamin: any;
  kts: any = {};

  info: string = 'Pemohon';
  foto: any = {};

  infox: string = '';

  fotoList: any;
  photoListOther: any;

  tampakDepan: any;
  tampakBelakang: any;
  tampakSamping1: any;
  tampakSamping2: any;

  tampakDepanx: any;
  tampakBelakangx: any;
  tampakSamping1x: any;
  tampakSamping2x: any;

  loadtampakDepan: boolean = false;
  loadtampakBelakang: boolean = false;
  loadtampakSamping1: boolean = false;
  loadtampakSamping2: boolean = false;

  listPhotoOtherx: any;
  photoOther1: any;
  photoOther2: any;
  photoOther3: any;
  photoOther4: any;
  photoOther5: any;
  photoOther6: any;

  photoOther1x: any = '';
  photoOther2x: any = '';
  photoOther3x: any = '';
  photoOther4x: any = '';
  photoOther5x: any = '';
  photoOther6x: any = '';

  loadphotoOther1: any;
  loadphotoOther2: any;
  loadphotoOther3: any;
  loadphotoOther4: any;
  loadphotoOther5: any;
  loadphotoOther6: any;

  tampakDepanxx: any;
  tampakBelakangxx: any;
  tampakSamping1xx: any;
  tampakSamping2xx: any;

  photoOther1xx: any;
  photoOther2xx: any;
  photoOther3xx: any;
  photoOther4xx: any;
  photoOther5xx: any;
  photoOther6xx: any;
  agunanx: any;
  fotoListx: any;

  kapasitas: any;

  credit_checkingSlik: any = {};
  credit_checkingPef: any = {};
  loaddownload1: boolean = false;
  token: any = '';
  baseUrl: any = '';

  oc: any = {};
  docIdentitas: any;
  docIdentitasx: any;
  docAgunan: any;
  docKapasitas: any;
  formx: any;

  adaDataAgunan: boolean = false;
  docAgunanCustom: any;
  docOtherIdentitas: any;
  docOtherIdentitasList: any[] = [];
  docOtherAgunan: any;
  docx: any;
  allfile: any;
  fp: any;

  btnCompleteAgunan: boolean = false;
  tenors: any;
  jaminan: any;

  idMap: any = {};
  gabunganAgunan: any = {};
  gabunganAgunanx: any;

  docIdentitasCustom: any;

  docIdentitasOther: any;

  loading: boolean = false;
  usertoken: any;
  progress: any = 0;

  dataLocal: any = {};

  pemohonx: any = {};
  params: any = {};
  pengajuanx: any = {};
  scoring: any = {};
  scoring_point: any = {};

  pointpurp: any = {};
  pointChar: any = 0;

  dataLocalx: any = {};

  institusi_id: any = '';
  institusi_keuangan: any = '';
  institusi_point: any = '';

  dataChar: any;
  getPointChar: any;

  ttt: any = {};
  tt: any;
  listBillx: any;

  pointCap: any = 0;
  dataCapa: any = {};

  totPengeluaran: any = 0;
  angsuranTempatlain: any = 0;
  dataPengeluaran: any = {};

  maksAngusuranDiambil: any = 0;
  max_angs_diambil: any;

  idir: any = '0';
  dsr: any = '0';

  qq: number = 0;
  ww: number = 0;

  cps: any = {};
  cp: any;

  lamaKerja: any = '';
  statusKawin: any = '';
  tenor: any = '';

  pointCond: any = 0;
  pointCapi: any = 0;
  pointColl: any = 0;

  scoring_cond: any;
  scoring_capi: any;
  scoring_ag: any;
  lama_kerja: any;
  status_perkawinan: any;
  tenorx: any;
  coll_agunan: any;
  coll: any;

  totalHargaTaksasi: any = 0;
  totalLtv: any = 0;
  textMerah: boolean = false;
  pcl: any = {};
  pc: any = {};

  btnload: boolean = false;
  purp: any;

  dataProses: any;
  proses_aset_id: any;
  proses_aset_point: any;
  index: any;
  pointCapId: any;

  rekom: any = {};
  rk: any = {};
  scoring_char: any;
  ringkasan: any = {};
  rekomendasi_surveyor: any = {};

  scoring_capa: any;

  flg_perubahan_akta: boolean = false;

  detMem: any = {};
  dm: any;

  credit_analyst: any = {};
  rrrrrrrrrrrrr: any;

  agunanCond: any;
  agunanColl: any;

  users: any;
  parent: any = {};
  children: any = {};
  action: any;

  act1: any;
  act2: any;
  act3: any;
  act4: any;
  isActionModalOpening: boolean = false;

  kondar_checkingSlik: any;
  kondar_checkingPef: any;

  a: any = 0;
  b: any = 0;
  c: any = 0;
  d: any = 0;
  e: any = 0;
  f: any = 0;

  fotoKTP: any = null;
  fotoKTPPas: any = null;
  agunandocs: any = [];
  hasDokumenIdentitasData: boolean = false;
  hasDokumenPendukungData: boolean = false;

  histories: any = [];
  checkingDataType: string = '';
  isAutoCreditChecking: boolean = false;
  cbiReportInfo: any = {};
  cbiSummary: any = {};
  cbiHasData: boolean = false;
  cbiFlagFetching: boolean = false;
  cbiReportFetching: boolean = false;
  cbiCreditTabPending: boolean = false;
  cbiAutoInitialized: boolean = false;
  cbiSelectedRole: 'pemohon' | 'pasangan' = 'pemohon';
  cbiAvailableRoles: Array<'pemohon' | 'pasangan'> = ['pemohon'];
  cbiShowRoleTabs: boolean = false;
  cbiIdentityMap: any = {
    pemohon: null,
    pasangan: null,
  };

  constructor(
    public api: ApiService,
    public util: UtilService,
    // public navParams: NavParams,
    public activatedRoute: ActivatedRoute,
    public modalController: ModalController,
    private dom: DomSanitizer,
    private platform: Platform,
    public http: HttpClient,
    public router: Router,
    private companyStorage: CompanyStorageService,
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params && params.no) {
        this.id = params.no;
        console.log('id', this.id);
        this.fp = params.fp;
        console.log('fp', this.fp);
        // this.fromPage = params.fromPage;
      }
    });
  }

  ngOnInit() {
    // this.riwayat();
    this.detailData();
    this.users = this.api.getUserMenu();
    this.addx();
  }

  onMainTabChange(event: any) {
    const tab = event?.detail?.value || this.info;
    requestAnimationFrame(() => {
      const wrap = document.querySelector('.ca-segment-wrap') as HTMLElement;
      const btn = wrap?.querySelector('ion-segment-button.segment-button-checked') as HTMLElement;
      if (wrap && btn) {
        wrap.scrollLeft = btn.offsetLeft - (wrap.clientWidth - btn.clientWidth) / 2;
      }
      document.querySelectorAll('ion-content').forEach((content: any) => {
        const scrollEl = content.shadowRoot?.querySelector('.inner-scroll') as HTMLElement;
        if (scrollEl) {
          scrollEl.style.overflowX = 'hidden';
          scrollEl.scrollLeft = 0;
        }
      });
    });

    if (tab !== 'Credit') {
      return;
    }
    if (this.load) {
      this.cbiCreditTabPending = true;
      return;
    }
    this.enterCreditCheckingTab();
  }

  onAutoCreditRoleSegmentChange(event: any) {
    const role = event?.detail?.value;
    this.changeAutoCreditRole(role);
  }

  addx() {
    try {
      this.parent = this.users.find(
        (item: any) => item.menu_id === 'Credit Analis',
      );
      this.children = this.parent.childrens.find(
        (item: any) => item.id === 'Approval Memorandum',
      );
      this.action = this.children.actions;
      console.log(this.users);
      console.log(this.children);
      console.log(this.action);

      this.act1 = this.action.find((item: any) => item === 'Proses');
      this.act2 = this.action.find((item: any) => item === 'Tolak');
      console.log(this.act1);
    } catch (error) {}
  }

  gabunganAgunanScoring() {
    const agunan = this.ensureArray(this.detList?.agunan);
    const scoring_agx = this.ensureArray(this.detList?.scoring?.cond_agunan);
    const combinedArray: any[] = [];

    agunan.forEach((item1: any) => {
      const item2 = scoring_agx.find(
        (item: any) => item.agunan_id === item1.id,
      );
      if (item2) {
        const combinedItem = Object.assign({}, item1, item2);
        combinedArray.push(combinedItem);
      }
    });
    this.agunanCond = combinedArray;
    console.log('combinedArray', combinedArray);
  }

  gabunganAgunanColl() {
    const agunan = this.ensureArray(this.detList?.agunan);
    const scoring_agx = this.ensureArray(this.detList?.scoring?.coll_agunan);
    const combinedArray: any[] = [];

    agunan.forEach((item1: any) => {
      const item2 = scoring_agx.find(
        (item: any) => item.agunan_id === item1.id,
      );
      if (item2) {
        const combinedItem = Object.assign({}, item1, item2);
        combinedArray.push(combinedItem);
      }
    });
    this.agunanColl = combinedArray;
    console.log('combinedArray', combinedArray);
  }

  async previewX(p: any, nama: any) {
    try {
      this.load = true;
      this.usertoken = localStorage.getItem('usertoken') || 'null';

      // Tangani kondisi jika p adalah array atau objek
      let url = '';

      if (typeof p === 'string') {
        url = this.api.convertUrlDownload(p);
      } else if (Array.isArray(p) && p.length > 0 && p[0].path) {
        url = this.api.convertUrlDownload(p[0].path);
      } else if (p?.path) {
        url = this.api.convertUrlDownload(p.path);
      } else {
        this.load = false;
        console.warn('Data file tidak ditemukan');
        return;
      }

      const headers = new HttpHeaders({
        Authorization: 'Bearer ' + this.usertoken,
        'X-Tenant-Key': this.companyStorage.getVerifyToken(),
      });

      if (this.platform.is('mobile')) {
        this.load = false;
        window.open(url, '_system');
      } else {
        this.http.get(url, { headers, responseType: 'blob' }).subscribe(
          (response: any) => {
            const blob = new Blob([response], { type: 'application/pdf' });
            const blobUrl = window.URL.createObjectURL(blob);
            this.load = false;
            window.open(blobUrl, '_blank');
          },
          (error) => {
              this.load = false;
              console.error('Gagal download file:', error);
            },
        );
      }
    } catch (error) {
      this.util.showToast('Url tidak terparsing', 'danger', 'bottom');
    }
  }

  detailMemoApp() {
    this.load = true;
    this.api.get('backoffice/credit-analyst/app-memo/' + this.id).subscribe(
      (data) => {
        this.detMem = data;
        if (this.detMem.error == 0) {
          this.load = false;
          if (this.detMem.data.total == 0) {
            this.dm = 'null';
          } else {
            this.dm = this.detMem.data.rows;
          }
        } else {
          this.load = false;
          this.util.showToast(this.detMem.message, 'success', 'bottom');
        }
      },
      (error) => {
          this.load = false;
          console.log('error', error);
          this.api.errorCond(error);
        },
    );
  }

  async prosess() {
    await this.openApproveRejectModal('ap');
  }

  async tolak() {
    await this.openApproveRejectModal('rj');
  }

  async revisi() {
    if (this.isActionModalOpening) {
      return;
    }

    this.isActionModalOpening = true;

    try {
      const topModal = await this.modalController.getTop();
      if (topModal) {
        return;
      }

      const modal = await this.modalController.create({
        component: MemorandumRevisiComponent,
        cssClass: 'modalFormRevisi',
        componentProps: {
          id: this.id,
        },
      });

      await modal.present();
      const data: any = await modal.onDidDismiss();

      if (data?.role === 'confirm') {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            refresh: true,
          },
        };
        this.router.navigate(['./approval-memorandum'], navigationExtras);
      }
    } catch (error) {
      console.log('revisi modal error', error);
      this.util.showToast(
        'Gagal membuka popup, silakan coba lagi.',
        'danger',
        'bottom',
      );
    } finally {
      this.isActionModalOpening = false;
    }
  }

  private async openApproveRejectModal(status: 'ap' | 'rj') {
    if (this.isActionModalOpening) {
      return;
    }

    if (!this.detList || Object.keys(this.detList).length === 0) {
      this.util.showToast(
        'Data belum siap, silakan coba lagi.',
        'warning',
        'bottom',
      );
      return;
    }

    this.isActionModalOpening = true;

    try {
      const topModal = await this.modalController.getTop();
      if (topModal) {
        return;
      }

      const modal = await this.modalController.create({
        component: MemorandumApproveRejectComponent,
        cssClass: 'modalForm',
        componentProps: {
          id: JSON.stringify(this.detList),
          st: status,
        },
      });

      await modal.present();
      const data: any = await modal.onDidDismiss();

      if (data?.role === 'confirm') {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            refresh: true,
          },
        };
        this.router.navigate(['./approval-memorandum'], navigationExtras);
      }
    } catch (error) {
      console.log('openApproveRejectModal error', error);
      this.util.showToast(
        'Gagal membuka popup, silakan coba lagi.',
        'danger',
        'bottom',
      );
    } finally {
      this.isActionModalOpening = false;
    }
  }

  captureImageGlobal(data: any, ss: any) {}

  async rekomen() {
    // const modal = await this.modalController.create({
    //   component: MemorandumRekomendasiComponent,
    //   cssClass: 'modalForm',
    //   componentProps: {
    //     id: JSON.stringify(this.detList)
    //   }
    // });
    // modal.onDidDismiss()
    //   .then((data: any) => {
    //     if (data.role === 'confirm') {
    //     }
    //   });
    // return await modal.present();
  }

  pilih(p) {
    console.log(p);
    if (this.selct == '') {
      this.selct = p;
    } else if (this.selct == p) {
      // this.selct = '';
    } else {
      this.selct = p;
    }
    console.log('selct', this.selct);
  }

  getNamePhoto(path: any) {
    const clean = path.split('?')[0];
    return clean.substring(clean.lastIndexOf('/') + 1);
  }

  async lihatI(id: any) {
    console.log(id);
    const modal = await this.modalController.create({
      component: PreviewImageNotokenComponent,
      cssClass: 'modalPreviewImage',
      componentProps: {
        id: id,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      if (data.role === 'confirm') {
        // this.ionViewWillEnter();
      }
    });
    return await modal.present();
  }

  detailData() {
    this.load = true;

    // console.log('fp',this.fp)
    // if (this.fp == 'am') {
    //   var url = 'backoffice/credit-analyst/app-memo-list/'
    // }else{
    var url = 'backoffice/credit-analyst/app-memo-list/';
    // }
    this.api.get(url + this.id).subscribe(
      (data) => {
        this.detData = data;
        if (this.detData.error == 0) {
          this.load = false;
          this.detList = this.detData.data;
          this.det = this.detData.data;
          this.lead_id = this.detList?.lead_id;
          this.header = this.detList?.header;
          this.credit_checking = this.detList?.credit_checking || {};
          this.pengajuan = this.detList?.pengajuan || '';
          this.pasangan = this.detList?.pasangan;
          this.pemohon = this.detList?.pemohon;
          this.agunan = this.detList?.agunan;
          this.foto = this.mergeMandatoryPhotosToMain(
            this.detList?.foto || this.detList?.dokumen?.foto || {},
          );
          this.penjamin = this.detList?.penjamin;
          this.kapasitas = this.detList?.kapasitas;
          this.fotoList = this.ensureArray(this.foto?.agunan?.main);
          this.fotoListx = this.ensureArray(this.foto?.agunan?.others);
          this.docIdentitasx = this.ensureArray(
            this.detList?.dokumen?.identitas,
          );
          this.ringkasan = this.detList?.ringkasan;
          this.histories = this.detList?.histories || '';
          this.rekomendasi_surveyor = this.ringkasan?.rekomendasi?.surveyor;
          this.credit_analyst = this.ringkasan?.rekomendasi?.credit_analyst;
          console.log('agunan', this.agunan);
          console.log('fotoList', this.fotoList);
          console.log('ringkasan', this.ringkasan);

          this.agunanx = this.mapAgunanPhotos();
          console.log('agunanx', this.agunanx);

          this.setupCreditCheckingDisplay();
          setTimeout(() => this.runPendingCreditCheckingFlow(), 0);

          const dokumen = this.det?.dokumen || {};
          const otherDokumen = dokumen?.others || {};

          const otherIdentitas = this.ensureArray(otherDokumen?.doc_identitas);
          this.docOtherIdentitas = otherIdentitas.length
            ? [otherIdentitas]
            : '';
          this.docOtherIdentitasList = otherIdentitas;

          const identitas = this.docIdentitasx.filter(
            (item: any) => item.name !== 'doc_identitas',
          );
          this.docIdentitas = identitas.filter(
            (item: any) => !Array.isArray(item),
          );
          console.log('docIdentitas', this.docIdentitas);

          const flatData = this.ensureArray(identitas).reduce(
            (acc: any[], item: any) => {
              if (Array.isArray(item)) {
                return acc.concat(item);
              }
              acc.push(item);
              return acc;
            },
            [],
          );
          // Cari objek dengan name 'KTP_PEMOHON'
          const ktpPemohon = flatData.find(
            (item: any) => item.name === 'KTP_PEMOHON',
          );
          // Masukkan path ke dalam variabel
          this.fotoKTP = ktpPemohon?.path || null;

          const ktpPasangan = flatData.find(
            (item: any) => item.name === 'KTP_PASANGAN',
          );
          this.fotoKTPPas = ktpPasangan?.path || null;

          this.agunandocs = this.ensureArray(dokumen?.agunan);
          const otherAgunan = this.ensureArray(otherDokumen?.doc_agunan);
          this.docOtherAgunan = otherAgunan.length ? [otherAgunan] : '';
          this.hasDokumenIdentitasData =
            this.ensureArray(this.docIdentitas).length > 0;
          this.hasDokumenPendukungData =
            this.docOtherIdentitasList.length > 0 ||
            this.ensureArray(this.agunandocs).length > 0;

          console.log('docOtherIdentitas', this.docOtherIdentitas);
          console.log('docOtherAgunan', this.docOtherAgunan);

          const docKapasitas = this.ensureArray(otherDokumen?.doc_kapasitas);
          this.docKapasitas = docKapasitas.length ? [docKapasitas] : '';
          console.log('docKapasitas', this.docKapasitas);

          // var identitas = this.docIdentitasx.filter((item: any) => item.name !== 'doc_identitas');
          // this.docIdentitas = identitas;
          // console.log('docIdentitas', this.docIdentitas);

          this.docAgunan = this.ensureArray(dokumen?.agunan);
          this.docAgunanCustom = otherAgunan.length ? [otherAgunan] : '';
          console.log('docAgunanCustom', this.docAgunanCustom);

          if (this.det.penjamin.length == 0) {
            this.penjamin = '';
          } else {
            this.penjamin = this.det.penjamin;
          }

          console.log('penjamin', this.penjamin);
          this.kts = this.det.kts;
          this.foto = this.mergeMandatoryPhotosToMain(this.det?.foto || {});
          try {
            this.tenors = Object.values(this.pengajuan.product.tenors);
          } catch (error) {}

          try {
            this.jaminan = Object.values(
              this.pengajuan.product.certificates_name,
            );
          } catch (error) {}

          this.gabunganAgunanScoring();
          this.gabunganAgunanColl();

          this.mergingData();
          // this.complete = this.hasil.data.complete;
          // this.enable = this.hasil.data.enable;
          this.load = false;

          if (this.agunan.length == 0) {
            this.btnCompleteAgunan = false;
            this.adaDataAgunan = false;
          } else {
            this.adaDataAgunan = true;
            var cariFlagComplete = this.agunan.find(
              (item: any) => item.flg_completed === false,
            );
            try {
              var rr = [cariFlagComplete];
              var tt = rr[0].id;
              console.log('rr', rr);
              console.log('tt', tt);
              this.btnCompleteAgunan = false;
            } catch (error) {
              this.btnCompleteAgunan = true;
              console.log('rr', 'KOSONG');
            }
          }
          this.dataLocal = this.detList;
          console.log('dataLocal', this.dataLocal);
          this.pemohonx = this.dataLocal.pemohon;
          this.dataCapa = this.dataLocal.scoring?.capa?.[0] || {};
          this.params = this.dataLocal?.params || {};
          this.pengajuan = this.dataLocal?.pengajuan || {};
          this.scoring = this.dataLocal?.scoring || {};
          this.scoring_point = this.dataLocal?.scoring_point || {};

          this.scoring_cond = this.ensureArray(this.scoring?.cond);
          this.scoring_capi = this.ensureArray(this.scoring?.capi);
          this.scoring_ag = this.ensureArray(this.scoring?.cond_agunan);
          this.scoring_char = this.ensureArray(this.scoring?.char);
          this.scoring_capa = this.ensureArray(this.scoring?.capa);

          this.pointChar = this.scoring_char.reduce(
            (acc: number, o: any) => acc + (parseFloat(o.point) || 0),
            0,
          );
          this.pointCap = this.calculateCapaPoint(this.scoring_capa);
          this.max_angs_diambil = this.params?.max_angs_diambil || '';

          this.coll_agunan = this.ensureArray(this.scoring?.coll_agunan);
          this.coll = this.ensureArray(this.scoring?.coll);
          this.load = false;

          console.log('this.coll', this.coll);

          // try {
          //   this.getPengeluaran();
          // } catch (error) {
          //   console.log('getPengeluaran', error)
          // }

          try {
            this.scoring = this.dataLocal.scoring || {};
            this.scoring_point = this.dataLocal?.scoring_point || {};
            this.scoring_cond = this.ensureArray(this.scoring?.cond);
            this.scoring_capi = this.ensureArray(this.scoring?.capi);
            this.coll_agunan = this.ensureArray(this.scoring?.coll_agunan);
            this.kalkulasiTaksasi();
          } catch (error) {
            console.log('coll', error);
          }
          this.kalkulasiAgunan();
          if (this.pengajuan.ltv_value !== '') {
            this.totalLtv = this.pengajuan.ltv_value;
          }
          this.getEditPengeluaran();
        } else {
          this.load = false;
          this.util.showToast(this.detData.message, 'success', 'bottom');
        }
      },
      (error) => {
          this.load = false;
          console.log('error', error);
          this.api.errorCond(error);
        },
    );
  }

  getDataChar() {
    try {
      if (this.scoring_char.length !== 0) {
        localStorage.setItem(
          '674e87yuh4e87ygh4fe87yjh4ef8yuh4yuasdasdhj',
          JSON.stringify(this.scoring_char),
        );
        this.dataChar = JSON.parse(
          localStorage.getItem('674e87yuh4e87ygh4fe87yjh4ef8yuh4yuasdasdhj') ||
            '',
        );
        this.kalkulasi();
      }
    } catch (error) {
      console.log('dataChar', error);
    }
  }

  kalkulasi() {
    // this.pointChar = this.dataChar.reduce((acc, o) => acc + parseFloat(o.point), 0);
    // this.updateLsChar();
  }

  updateLsChar() {
    // UPDATE LOCALSTORAGE
    this.dataProses = JSON.parse(
      localStorage.getItem('87gr3u4g37gf37yf34yf36y74f37437y4fghshdjf') || '',
    );
    this.scoring = this.dataProses.scoring;
    let ax =
      localStorage.getItem('674e87yuh4e87ygh4fe87yjh4ef8yuh4yuasdasdhj') || '';
    this.dataChar = JSON.parse(ax);
    // Char
    this.dataProses.scoring.char = this.dataChar;
    console.log('dataProses', this.dataProses);
    localStorage.setItem(
      '87gr3u4g37gf37yf34yf36y74f37437y4fghshdjf',
      JSON.stringify(this.dataProses),
    );
  }

  getPengeluaran() {
    try {
      try {
        this.dataPengeluaran = JSON.parse(
          localStorage.getItem('5643ter34vt34t34t34rsdre4tse5tv45egv54t4') ||
            '',
        );
      } catch (error) {
        this.dataPengeluaran = '';
      }
      console.log('dataPengeluaran', this.dataPengeluaran);

      if (this.dataPengeluaran !== '') {
        this.totPengeluaran = this.dataPengeluaran.totalPengeluaran;
        console.log('totPengeluaran', this.totPengeluaran);
        this.angsuranTempatlain = this.dataPengeluaran.angsuranTempatLain;
        // =(Total Penghasilan*max_angs_diambil%)-total pengeluaran
        try {
          this.maksAngusuranDiambil =
            (this.dataCapa.total_penghasilan * this.params.max_angs_diambil) /
              100 -
              this.totPengeluaran || '-';
        } catch (error) {}
        // =((Angsuran Tempat Lain + Angsuran Diambil)/Total Penghasilan)*100
        this.qq =
          ((parseInt(this.angsuranTempatlain) +
            parseInt(this.dataCapa.angs_diambil)) /
            this.dataCapa.total_penghasilan) *
            100 || 0;
        this.dsr = this.qq.toFixed(2);
        // =((Angsuran diambil+total pengeluaran)/total penghasilan)*100;
        this.ww =
          ((parseInt(this.dataCapa.angs_diambil) +
            parseInt(this.totPengeluaran)) /
            this.dataCapa.total_penghasilan) *
            100 || 0;
        this.idir = this.ww.toFixed(2);
        //POINT CAPACITY
        // try {
        //   var pointCap = this.cp.filter((list) => this.idir >= list.range_min && this.idir <= list.range_max)
        //   this.pointCap = pointCap[0].point;
        //   this.pointCapId = pointCap[0].id;
        //   console.log('maksAngusuranDiambil ', ' = (' + this.dataCapa.total_penghasilan + '*' + this.params.max_angs_diambil + '/100) -' + this.totPengeluaran)
        //   console.log('dsr ', '= ((' + this.angsuranTempatlain + '+' + this.dataCapa.angs_diambil + ')/' + this.dataCapa.total_penghasilan + ')*100')
        //   console.log('idir ', '= ((' + this.dataCapa.angs_diambil + '+' + this.totPengeluaran + ')/' + this.dataCapa.total_penghasilan + ')*100')
        // } catch (error) {
        //   console.log(error)
        // }

        try {
          this.pointCap = this.calculateCapaPoint(this.detList?.scoring?.capa);
        } catch (error) {
          console.log(error);
          this.pointCap = 0;
        }
        // UPDATE LOCALSTORAGE
        this.dataProses = JSON.parse(
          localStorage.getItem('87gr3u4g37gf37yf34yf36y74f37437y4fghshdjf') ||
            '',
        );
        this.scoring = this.dataProses.scoring;
        // CAPA
        this.dataProses.scoring.capa[0].dsr = this.dsr;
        this.dataProses.scoring.capa[0].id = this.pointCapId;
        this.dataProses.scoring.capa[0].point = this.pointCap;
        this.dataProses.scoring.capa[0].idir = this.idir;
        this.dataProses.scoring.capa[0].max_angs = this.maksAngusuranDiambil;
        console.log('dataProses', this.dataProses);
        localStorage.setItem(
          '87gr3u4g37gf37yf34yf36y74f37437y4fghshdjf',
          JSON.stringify(this.dataProses),
        );
      } else {
        this.totPengeluaran = '-';
        this.maksAngusuranDiambil = '-';
      }
    } catch (error) {
      console.log(error);
      this.totPengeluaran = '-';
    }
  }

  kalkulasiTaksasi() {
    try {
      this.totalHargaTaksasi = this.coll_agunan.reduce(
        (acc, o) => acc + parseFloat(o.taksasi),
        0,
      );
    } catch (error) {
      this.totalHargaTaksasi = 0;
    }
    this.totalHargaTaksasi = isNaN(this.totalHargaTaksasi)
      ? 0
      : this.totalHargaTaksasi;
    console.log('totalHargaTaksasi', this.totalHargaTaksasi);
    this.kalkulasiLtv();
  }

  isNumber(value) {
    return Number.isNaN(value);
  }

  kalkulasiLtv() {
    console.log(
      'this.pengajuan.submission_loan',
      this.pengajuan.submission_loan,
    );
    console.log('totalHargaTaksasi', this.totalHargaTaksasi);
    var totalLtv =
      (this.pengajuan.submission_loan / this.totalHargaTaksasi) * 100;
    this.totalLtv = totalLtv.toFixed(2);
    // this.totalLtv = isNaN(this.totalLtv) ? 0 : this.totalLtv;
    // console.log('totalLtv',this.totalLtv)
    if (this.totalLtv >= this.pengajuan.ltv_value) {
      this.textMerah = true;
    } else {
      this.textMerah = false;
    }
    this.getPointColl();
  }

  getPointColl() {
    try {
      this.pointColl = this.coll_agunan.reduce((acc, o) => {
        const point = parseFloat(o.point);
        return isNaN(point) ? acc : acc + point;
      }, 0);
      if (!this.pointColl) {
        this.pointColl = this.detList.scoring?.coll?.[0]?.point || 0;
      }
    } catch (error) {
      console.log(error);
      this.pointColl = 0;
    }
    // this.load = true;
    // let form = JSON.stringify({
    //   ltv: this.totalLtv,
    // });
    // this.api.post('surveyor/prospects/skoring/point/coll', form)
    //   .subscribe((data) => {
    //     this.pcl = data;
    //     if (this.pcl.error == 0) {
    //       this.load = false;
    //       this.pc = this.pcl.data;
    //       this.pointColl = this.pc.point;
    //       this.updateLSCol();
    //     } else {
    //       this.load = false;
    //       this.util.showToast(this.pcl.message, 'danger', 'bottom');
    //     }
    //   }, (error) => {
    //     this.load = false;
    //     console.log('error', error);
    //     this.api.errorCond(error)
    //   });
  }

  kalkulasiAgunan() {
    this.pointCond = this.scoring_cond.reduce(
      (acc: number, o: any) => acc + (parseFloat(o.point) || 0),
      0,
    );
    this.pointCapi = this.scoring_capi.reduce(
      (acc: number, o: any) => acc + (parseFloat(o.point) || 0),
      0,
    );
    console.log('pointCond', this.pointCond);
  }

  getEditPengeluaran() {
    console.log('dataCapa', this.dataCapa);
    this.form = JSON.stringify({
      rumahTangga: this.dataCapa.pengeluaran_rumah_tangga || null,
      angsuranTempatLain: this.dataCapa.pengeluaran_angs_tempat_lain || null,
      biayaLainya: this.dataCapa.pengeluaran_biaya_lainnya || null,
      totalPengeluaran: this.dataCapa.total_pengeluaran || null,
    });
    // }
    var t = this.form;
    localStorage.setItem('5643ter34vt34t34t34rsdre4tse5tv45egv54t4', t);
  }

  updateLSCol() {
    // UPDATE LOCALSTORAGE
    this.dataProses = JSON.parse(
      localStorage.getItem('87gr3u4g37gf37yf34yf36y74f37437y4fghshdjf') || '',
    );
    this.scoring = this.dataProses.scoring;
    // CAPA
    this.dataProses.scoring.coll[0].id = this.pc.id;
    this.dataProses.scoring.coll[0].ltv = this.totalLtv;
    this.dataProses.scoring.coll[0].point = this.pointColl;
    this.dataProses.scoring.coll[0].text = this.totalLtv;
    this.dataProses.scoring.coll[0].total_taksasi = this.totalHargaTaksasi;
    this.dataProses.scoring.coll[0].value = this.totalLtv;
    console.log('dataProses', this.dataProses);
    localStorage.setItem(
      '87gr3u4g37gf37yf34yf36y74f37437y4fghshdjf',
      JSON.stringify(this.dataProses),
    );
  }

  async tambah(id: any) {
    // const modal = await this.modalController.create({
    //   component: KolektorPenagihanAddComponent,
    //   cssClass: 'modalForm',
    //   componentProps: {
    //     id: id
    //   }
    // });
    // modal.onDidDismiss()
    //   .then((data: any) => {
    //     if (data.role === 'confirm') {
    //       this.detailData();
    //     }
    //   });
    // return await modal.present();
  }

  riwayat() {
    this.api
      .get('backoffice/kolektor/penagihan/riwayat-pemby/' + this.id + '/1')
      .subscribe(
        (data) => {
          this.riwPem = data;
          if (this.riwPem.error == 0) {
            this.rw = this.riwPem.data;
          } else {
            this.load = false;
            this.util.showToast(this.riwPem.message, 'success', 'bottom');
          }
        },
        (error) => {
            this.load = false;
            console.log('error', error);
            this.api.errorCond(error);
          },
      );
  }

  save() {
    this.load = true;
    var arrayData = [this.id];
    if (this.ids == '') {
      this.form = {
        contract_id: arrayData,
        assign_to: this.selct,
      };
    } else {
      this.form = {
        contract_id: JSON.parse(this.ids),
        assign_to: this.selct,
      };
    }
    this.api
      .post('backoffice/kolektor/penagihan/assignto', this.form)
      .subscribe(
        (data) => {
          this.saving = data;
          if (this.saving.error == 0) {
            this.load = false;
            this.util.showToast(this.saving.message, 'success', 'bottom');
            this.api.dismissData('', 'confirm');
          } else {
            this.load = false;
            this.util.showToast(this.saving.message, 'danger', 'bottom');
          }
        },
        (error) => {
            this.load = false;
            console.log('error', error);
            this.api.errorCond(error);
          },
      );
  }

  handleSelection(selectedValue: string, model: any) {
    if (model == 'cabang') {
      this.cabang = selectedValue;
    } else if (model == 'usertype') {
      this.usertype = selectedValue;
    }
  }

  dismiss() {
    this.api.dismiss();
  }

  async preview(photo: any) {
    const modal = await this.modalController.create({
      component: PreviewPhotoLaporanComponent,
      cssClass: 'modalPreviewImage',
      // handle: false,
      backdropDismiss: false,
      // breakpoints: [0.5, 0.9, 1],
      // initialBreakpoint: 0.5,
      componentProps: {
        id: photo,
      },
    });
    modal.onDidDismiss().then((data) => {});
    return await modal.present();
  }

  mergingData() {
    try {
      const agunanList = this.ensureArray(this.agunan);
      const docAgunanList = this.ensureArray(this.docAgunan);
      const otherAgunanList = this.ensureArray(this.docOtherAgunan?.[0]);
      const fotoOtherList = this.ensureArray(this.fotoListx);

      this.gabunganAgunanx = agunanList.map((item: any) => {
        const docs = this.getByAgunan(docAgunanList, item.id, true);
        const others = this.getByAgunan(otherAgunanList, item.id, true);
        const fotoByAgunan = this.getByAgunan(fotoOtherList, item.id, true);

        const bpkb = fotoByAgunan
          .filter((x: any) => x.name === 'BPKB')
          .slice(0, 1);
        const stnk = fotoByAgunan
          .filter((x: any) => x.name === 'STNK')
          .slice(0, 1);
        const shmshgb = fotoByAgunan
          .filter((x: any) => x.name === 'SHM_SHGB')
          .slice(0, 1);
        const allDocs = [...docs, ...others];

        return {
          ...item,
          bpkb: bpkb.length ? bpkb : undefined,
          stnk: stnk.length ? stnk : undefined,
          shmshgb: shmshgb.length ? shmshgb : undefined,
          other: others.length ? [others] : undefined,
          document: allDocs.length ? [allDocs] : undefined,
        };
      });

      console.log('gabunganAgunanx', this.gabunganAgunanx);
      console.log('agunan', this.agunan);

      console.log('docIdentitas', this.docIdentitas);
      console.log('docIdentitasCustom', this.docIdentitasCustom);
    } catch (error) {
      console.log('mergingData Error / Data DOkumenKosong', error);
      this.gabunganAgunanx = this.docAgunan;
    }
  }

  getBPKB(data: any, name: any) {
    var a = data.find((item: any) => item.name === name);
    return a;
  }

  private mapAgunanPhotos() {
    const agunanList = this.ensureArray(this.agunan);
    const mainPhotos = this.ensureArray(this.fotoList);
    const otherPhotos = this.ensureArray(this.fotoListx);

    return agunanList.map((item: any) => ({
      ...item,
      foto: this.getMainPhotosByAgunan(mainPhotos, item.id),
      other: this.getByAgunan(otherPhotos, item.id, true),
    }));
  }

  private getMainPhotosByAgunan(mainPhotos: any[], agunanId: any) {
    const list = this.ensureArray(mainPhotos);
    const isSingleAgunan = this.ensureArray(this.agunan).length === 1;
    const byAgunan = list.filter((item: any) => item?.ref_id_2 === agunanId);
    const globalPhotos = list.filter((item: any) => !item?.ref_id_2);
    const merged = byAgunan.length
      ? isSingleAgunan
        ? [...byAgunan, ...globalPhotos]
        : byAgunan
      : isSingleAgunan
        ? list
        : [];

    const uniqueMap = new Map<string, any>();
    merged.forEach((item: any) => {
      const key = `${item?.path || ''}-${item?.name || ''}`;
      if (!item?.path) {
        return;
      }
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, item);
      }
    });

    return Array.from(uniqueMap.values());
  }

  private mergeMandatoryPhotosToMain(foto: any) {
    const source = foto || {};
    const mandatoryPhotos = this.extractMandatoryPhotos(source);
    const mainPhotos = this.ensureArray(source?.agunan?.main);
    const mergedMain = [...mainPhotos];
    const existingPath = new Set(
      mainPhotos.map((item: any) => item?.path).filter((path: any) => !!path),
    );

    mandatoryPhotos.forEach((item: any) => {
      if (!item?.path || existingPath.has(item.path)) {
        return;
      }
      existingPath.add(item.path);
      mergedMain.push(item);
    });

    return {
      ...source,
      agunan: {
        ...(source?.agunan || {}),
        main: mergedMain,
        others: this.ensureArray(source?.agunan?.others),
      },
    };
  }

  private extractMandatoryPhotos(source: any) {
    return this.mandatoryPhotoKeys
      .map((key: string) => {
        const path = source?.[key];
        if (typeof path !== 'string' || !path.trim()) {
          return null;
        }
        return {
          id: key,
          name: key.replace(/_/g, ' ').toUpperCase(),
          notes: key,
          path: path.trim(),
        };
      })
      .filter((item: any) => !!item);
  }

  private getByAgunan(
    items: any[],
    agunanId: any,
    fallbackWhenSingle: boolean,
  ) {
    const list = this.ensureArray(items);
    const filtered = list.filter((item: any) => item?.ref_id_2 === agunanId);

    if (
      filtered.length === 0 &&
      fallbackWhenSingle &&
      this.ensureArray(this.agunan).length === 1
    ) {
      return list;
    }

    return filtered;
  }

  private ensureArray(data: any): any[] {
    return Array.isArray(data) ? data : [];
  }

  private calculateCapaPoint(capaList: any): number {
    return this.ensureArray(capaList).reduce((acc: number, item: any) => {
      const point = parseFloat(item?.point);
      return acc + (isNaN(point) ? 0 : point);
    }, 0);
  }

  isCreditCheckingEmpty(): boolean {
    const emptySlik =
      !this.credit_checkingSlik ||
      (Array.isArray(this.credit_checkingSlik) &&
        this.credit_checkingSlik.length === 0);
    const emptyPef =
      !this.credit_checkingPef ||
      (Array.isArray(this.credit_checkingPef) &&
        this.credit_checkingPef.length === 0);
    return emptySlik && emptyPef;
  }

  private setupCreditCheckingDisplay() {
    this.checkingDataType = this.normalizeCheckingDataType(
      this.detList?.credit_checking_type,
    );
    this.isAutoCreditChecking = this.checkingDataType === 'otomatis';

    this.credit_checkingSlik = this.credit_checking?.slik || '';
    this.credit_checkingPef = this.credit_checking?.pefindo || '';

    if (
      Array.isArray(this.credit_checkingSlik) &&
      this.credit_checkingSlik.length === 0
    ) {
      this.credit_checkingSlik = '';
    }
    if (
      Array.isArray(this.credit_checkingPef) &&
      this.credit_checkingPef.length === 0
    ) {
      this.credit_checkingPef = '';
    }

    this.kondar_checkingSlik = this.credit_checkingSlik?.penjamin || 'null';
    this.kondar_checkingPef = this.credit_checkingPef?.penjamin || 'null';

    if (this.isAutoCreditChecking) {
      this.resetAutoCreditCheckingState();
      return;
    }

    this.cbiReportInfo = {};
    this.cbiSummary = {};
    this.cbiHasData = false;
    this.resetAutoCreditCheckingState();
  }

  private runPendingCreditCheckingFlow() {
    if (!this.load && this.info === 'Credit' && this.cbiCreditTabPending) {
      this.enterCreditCheckingTab();
    }
  }

  private enterCreditCheckingTab() {
    if (!this.isAutoCreditChecking) {
      return;
    }

    if (this.load) {
      this.cbiCreditTabPending = true;
      return;
    }

    this.cbiCreditTabPending = false;
    if (this.cbiAutoInitialized) {
      return;
    }

    if (!this.pemohon?.identity_number || !this.pemohon?.birth_date) {
      return;
    }

    this.fetchAutoCreditFlagThenReport();
  }

  hasAutoCreditSpouse(): boolean {
    return this.cbiAvailableRoles.includes('pasangan');
  }

  showAutoCreditRoleTabs(): boolean {
    return this.cbiShowRoleTabs;
  }

  private changeAutoCreditRole(role: 'pemohon' | 'pasangan') {
    if (!this.isAutoCreditChecking) {
      return;
    }

    if (!role || role === this.cbiSelectedRole) {
      return;
    }

    if (role === 'pasangan' && !this.hasAutoCreditSpouse()) {
      return;
    }

    this.cbiSelectedRole = role;
    this.fetchAutoCreditReportByActiveRole();
  }

  private fetchAutoCreditFlagThenReport() {
    if (this.load) {
      this.cbiCreditTabPending = true;
      return;
    }

    if (this.cbiFlagFetching) {
      return;
    }

    if (!this.pemohon?.identity_number || !this.pemohon?.birth_date) {
      return;
    }

    const leadid = (this.lead_id || '').toString().trim();
    if (!leadid) {
      return;
    }

    this.cbiFlagFetching = true;
    this.getCbiToken(
      (token: string) => {
        const flagUrl = '/api/v2/get_flag?leadid=' + encodeURIComponent(leadid);
        this.api.getCbiManual(flagUrl, token).subscribe(
          (res: any) => {
            const isNotFound = this.isFlagNotFoundResponse(res);
            this.prepareAutoCreditRoles(res?.data || {}, isNotFound);
            this.cbiAutoInitialized = true;
            this.cbiFlagFetching = false;
            this.fetchAutoCreditReportByActiveRole();
          },
          () => {
            this.prepareAutoCreditRoles({}, true);
            this.cbiAutoInitialized = true;
            this.cbiFlagFetching = false;
            this.fetchAutoCreditReportByActiveRole();
          },
        );
      },
      () => {
        this.cbiFlagFetching = false;
      },
    );
  }

  private fetchAutoCreditReportByActiveRole() {
    if (this.cbiReportFetching) {
      return;
    }

    if (this.cbiFlagFetching) {
      return;
    }

    if (this.load) {
      return;
    }

    const leadid = (this.lead_id || '').toString().trim();
    const person = this.cbiIdentityMap?.[this.cbiSelectedRole] || {};
    const nik = (person?.identity_number || '').toString().trim();
    const dob = (person?.birth_date || '').toString().trim();

    if (!leadid || !nik || !dob) {
      this.cbiReportInfo = {};
      this.cbiSummary = {};
      this.cbiHasData = false;
      return;
    }

    this.cbiReportFetching = true;
    this.getCbiToken(
      (token: string) => {
        const url =
          '/api/v2/get_report?leadid=' +
          encodeURIComponent(leadid) +
          '&nik=' +
          encodeURIComponent(nik) +
          '&dob=' +
          encodeURIComponent(dob);
        this.api.getCbiManual(url, token).subscribe(
          (res: any) => {
            const bureauReport = res?.data?.BureauReport || {};
            this.cbiReportInfo = bureauReport?.ReportInfo || {};
            this.cbiSummary = bureauReport?.Summary || {};
            this.cbiHasData = Object.keys(this.cbiSummary).length > 0;
            this.cbiReportFetching = false;
          },
          () => {
              this.cbiReportInfo = {};
              this.cbiSummary = {};
              this.cbiHasData = false;
              this.cbiReportFetching = false;
            },
        );
      },
      () => {
        this.cbiReportFetching = false;
      },
    );
  }

  private prepareAutoCreditRoles(flagData: any, hideTabs: boolean = false) {
    const flagPemohon = this.extractPersonFromFlag(flagData, 'pemohon');
    const flagPasangan = this.extractPersonFromFlag(flagData, 'pasangan');
    const hasFlagPasangan = !!flagPasangan;

    const fallbackPemohon = this.extractPersonFromSource(this.pemohon);
    const fallbackPasangan = this.extractPersonFromSource(this.pasangan);

    const pemohon = flagPemohon || fallbackPemohon;
    const pasangan = hasFlagPasangan ? flagPasangan || fallbackPasangan : null;

    this.cbiIdentityMap = {
      pemohon,
      pasangan,
    };

    this.cbiAvailableRoles = ['pemohon'];
    if (hasFlagPasangan && pasangan) {
      this.cbiAvailableRoles.push('pasangan');
    }

    this.cbiShowRoleTabs = !hideTabs && this.cbiAvailableRoles.length > 1;
    this.cbiSelectedRole = 'pemohon';
  }

  private isFlagNotFoundResponse(res: any): boolean {
    const topCode = Number(res?.code ?? res?.status);
    const nestedCode = Number(res?.status?.code);
    return topCode === 404 || nestedCode === 404;
  }

  private extractPersonFromFlag(flagData: any, role: 'pemohon' | 'pasangan') {
    const byRole = flagData?.[role];
    const byAlias = role === 'pemohon' ? flagData?.applicant : flagData?.spouse;
    return this.extractPersonFromSource(byRole || byAlias);
  }

  private extractPersonFromSource(source: any) {
    const identity_number = (
      source?.identity_number ||
      source?.nik ||
      source?.id_number ||
      ''
    )
      .toString()
      .trim();
    const birth_date = (
      source?.birth_date ||
      source?.dob ||
      source?.date_of_birth ||
      ''
    )
      .toString()
      .trim();

    if (!identity_number || !birth_date) {
      return null;
    }

    return {
      identity_number,
      birth_date,
    };
  }

  private getCbiToken(onSuccess: (token: string) => void, onError: () => void) {
    const tokenCbi = localStorage.getItem('tokenCbi') || '';
    if (tokenCbi) {
      onSuccess(tokenCbi);
      return;
    }

    this.api.postCbi('api/v2/token', { value: 'YANGPENTINGADABODY' }).subscribe(
      (tokenRes: any) => {
        const token = tokenRes?.data?.accessToken || '';
        if (!token) {
          onError();
          return;
        }
        localStorage.setItem('tokenCbi', token);
        onSuccess(token);
      },
      () => {
        onError();
      },
    );
  }

  private resetAutoCreditCheckingState() {
    this.cbiFlagFetching = false;
    this.cbiReportFetching = false;
    this.cbiCreditTabPending = false;
    this.cbiAutoInitialized = false;
    this.cbiSelectedRole = 'pemohon';
    this.cbiAvailableRoles = ['pemohon'];
    this.cbiShowRoleTabs = false;
    this.cbiIdentityMap = {
      pemohon: null,
      pasangan: null,
    };
  }

  private normalizeCheckingDataType(value: any): string {
    return String(value || '')
      .trim()
      .toLowerCase();
  }
}